import type { ComponentType, ReactNode } from "react";

/** EmptyStatePresentational (Supabase fragment), in shop vocabulary. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon?: ComponentType<{ className?: string }>;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-md border border-dashed border-border-soft bg-card/50 px-6 py-12 text-center">
      {Icon ? <Icon className="size-8 text-faint-foreground" aria-hidden /> : null}
      <div className="grid gap-1">
        <p className="text-sm font-medium text-foreground">{title}</p>
        {description ? <p className="max-w-sm text-sm text-muted-foreground">{description}</p> : null}
      </div>
      {action}
    </div>
  );
}

